<template>
  <div>
    <a-modal
      v-model="visible"
      :title="$t('pdf')"
      :maskClosable="false"
      :okText="$t('print')"
      :cancelText="$t('cancel')"
      :cancelButtonProps="{ class: 'btn ts-whitespace-no-wrap btn-default' }"
      :confirmLoading="waiting"
      :footer="null"
      :zIndex="2000"
      :width="'100vw'"
      :bodyStyle="{ height: '120vh', padding: 0 }"
      wrapClassName="fullscreen-modal"
      @cancel="onCancel"
    >
      <div id="container">
        <i class="fa fa-spinner spin fa-2x text-white" v-if="printing"></i>
        <iframe v-if="!printing" :src="src"></iframe>
      </div>
    </a-modal>
  </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  name: 'pdfPreview',
  props: ['value', 'classId', 'acpsId'],

  data() {
    return {
      show: false,
      waiting: false,
      printing: false,
      src: ''
    }
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    ...mapActions('studentScoringEntry', ['previewPDF']),

    onCancel() {
      this.src = ''
      this.$emit('cancel', false)
    }
  },
  watch: {
    value: function(value) {
      if (value && this.classId > 0) {
        this.show = value
        this.printing = true
        const payload = { 
        class_id: this.classId,
        acps_id: this.acpsId 
      }
        this.$store
          .dispatch('studentScoringEntry/previewPDF', payload)
          .then(response => {
            this.src = response.url
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => {
            this.printing = false
          })
      }
    }
  }
}
</script>

<style scoped>
#container {
  width: 100%;
  height: 100%;
  background: black;
  text-align: center;
}

#container iframe {
  width: 100%;
  height: 100%;
  border: none;
}

#container i {
  margin-top: 40vh;
}

/* make modal fullscreen */
::v-deep(.fullscreen-modal .ant-modal) {
  top: 0 !important;
  padding: 0;
  max-width: 100%;
  height: 100%;
}

::v-deep(.fullscreen-modal .ant-modal-content) {
  height: 100%;
  border-radius: 0;
}
</style>
